export enum FuzzySearchType {
    StartWith = "startWith",
    EndWith = "endWith",
    Contains = "contains",
}
